function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MetricConversions from 'libs/MetricConversions';
import { ProfileContext } from 'context';
import { createKPIData } from 'helpers/kpi';
import { getStandards } from 'helpers/standards';
import App from 'modules/App';
import Account from 'modules/Account';
export const useKpiCalculations = (readingsCollections, daysCounts)=>{
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const clinicSettings = useSelector(profileContext.selectors.clinicSettings);
    const countrySettings = useSelector(App.selectors.countrySettings);
    const metricsUnits = useSelector(Account.selectors.metricsUnits);
    const [calculations, setCalculations] = useState();
    useEffect(()=>{
        const metricConversions = new MetricConversions(metricsUnits);
        const conversion = metricConversions.bloodGlucoseConcentration;
        const standards = getStandards(phiSet, countrySettings, clinicSettings);
        // TODO: Change usages of createKPIData to useKpiCalculations
        //  and move createKPIData here as local getKpiCalculations
        const kpiCalculations = createKPIData(_object_spread_props(_object_spread({}, readingsCollections, daysCounts), {
            standards,
            conversion
        }));
        setCalculations(kpiCalculations);
    }, [
        readingsCollections.readings,
        phiSet
    ]);
    return calculations;
};
